export default __webpack_public_path__ + "static/media/35.877773b5.jfif";